// Uygulamanın gerçek sayfaları. İstemci bununla 404 sayfasını seçer, sunucu da doğru durum kodunu döner.
const LESSON = /^\/ders\/([a-z0-9]{4,20})\/?$/;
const PAGES = /^\/(giris|kayit|yonetim|sifremi-unuttum|sifre-sifirla|e-posta-dogrula|gizlilik|kvkk|kullanim-kosullari|derslerim|derslerim\/[a-z0-9]{4,20}|ogrencilerim|profil)?\/?$/;

export const lessonIdFromPath = (path: string): string | null => LESSON.exec(path)?.[1] ?? null;
export const isAppRoute = (path: string): boolean => PAGES.test(path) || LESSON.test(path);
